module.exports = __webpack_public_path__ + "media/images/icon__close--rb-gray@3x-36007ab8b60750d597fdafb6e14e94e7.png";